import React from "react";
import { Container } from "react-bootstrap";

const Footer = ({ userInfo }) => {
  const rewardsId = userInfo?.rewardsId;
  const propertyName = process.env.REACT_APP_PROPERTY_DISPLAY_NAME;

  return (
    <Container fluid className="gcotg-footer">
      <a href={`mailto:cs@giftcardselection.com?subject=Gift card inquiry from ${propertyName} guest #${rewardsId}`}>
        Click here to email customer service
      </a>
    </Container>
  );
};

export default Footer;
